export default{
  clients:{
    title: '評価と受賞',
    description: 'MaesInfoはお客様に優れた成果を提供することに専心しています。',
    clients:[
      require('../../assets/images/services/client (1).jpg'),
      require('../../assets/images/services/client (2).jpg'),
      require('../../assets/images/services/client (3).jpg'),
      require('../../assets/images/services/client (4).jpg'),
      require('../../assets/images/services/client (5).jpg'),
      require('../../assets/images/services/client (6).jpg'),
      require('../../assets/images/services/client (7).jpg'),
      require('../../assets/images/services/client (8).jpg'),
      require('../../assets/images/services/client (9).jpg'),
      require('../../assets/images/services/client (10).jpg'),
    ]
  }
}
